// extracted by mini-css-extract-plugin
export var wordContainer = "_mp-0";